import clsx from "clsx";
import Icon from "./Icon/Icon";

//Classname should be used for the width of the arrow, the arrowclass can be
//used for the fill. The group needs to be a parent of this component.
export default function HoverArrowLink({
  arrowClass,
  arrowType = "small",
  className,
  direction = "right",
}: {
  arrowClass: string;
  arrowType?: "small" | "thin" | "long";
  className?: string;
  direction?: "right" | "bottom" | "left" | "down" | "diagonal";
}) {
  const iconName = {
    small: "hoverArrow",
    thin: "thinHoverArrow",
    long: "longArrow",
  } as const;
  const iconType = iconName[arrowType];
  return (
    <span
      className={clsx(
        "relative inline-block overflow-hidden",
        arrowType !== "long" && "aspect-square",
        className && className,
      )}
    >
      <span
        className={clsx(
          "absolute left-0 top-0 h-full w-full transition-transform",
          direction === "right" && "translate-x-0 group-hover:translate-x-full",
          direction === "bottom" &&
            "-translate-y-full rotate-90 group-hover:translate-y-0",
          direction === "left" &&
            "translate-x-0 rotate-180 group-hover:-translate-x-full",
          direction === "down" && "translate-y-0 group-hover:translate-y-full",
          direction === "down" && arrowType === "small" && "rotate-90",
          direction === "diagonal" &&
            "translate-x-0 translate-y-0 -rotate-45 group-hover:-translate-y-full group-hover:translate-x-full",
        )}
      >
        <Icon type={iconType} className={arrowClass} />
      </span>
      <span
        className={clsx(
          "absolute left-0 top-0 h-full w-full transition-transform",
          direction === "right" &&
            "-translate-x-full group-hover:translate-x-0",
          direction === "bottom" &&
            "translate-y-0 rotate-90 group-hover:translate-y-full",
          direction === "left" &&
            "translate-x-full rotate-180 group-hover:translate-x-0",
          direction === "down" && "-translate-y-full group-hover:translate-y-0",
          direction === "down" && arrowType === "small" && "rotate-90",
          direction === "diagonal" &&
            "-translate-x-full translate-y-full -rotate-45 group-hover:translate-x-0 group-hover:translate-y-0",
        )}
      >
        <Icon type={iconType} className={arrowClass} />
      </span>
    </span>
  );
}
